// extracted by mini-css-extract-plugin
export default {"customerInfoForm":"CustomerBillingInfoForm_customerInfoForm__QI5Id","label":"CustomerBillingInfoForm_label__FyqCx","fieldError":"CustomerBillingInfoForm_fieldError__3OxEK"};